/**
 * Real Google reviews of Danish Wedding, shown one at a time in the press
 * strip (GoogleReviews.tsx).
 *
 * Legal rules (UWG § 5 / § 5b Abs. 3 DE, § 2 AT, Art. 3 CH, EU Omnibus
 * Directive):
 * - Copy every review verbatim from the Google profile — spelling, line
 *   breaks and emoji included. Never shorten, correct, translate or merge
 *   reviews here. The page may clamp long ones visually, but the full text
 *   is always one click away.
 * - Only reviews that are live on Google. Delete an entry as soon as it
 *   disappears there.
 * - Dates as month and year: Google's "vor 1 Woche" goes stale on a website.
 * - No total rating or review count unless it is read from the profile
 *   (socialProof.ts gates that separately).
 * - Wherever the reviews are shown, the page must say where they come from
 *   and how we check that the authors used the service (§ 5b Abs. 3 UWG).
 *   GoogleReviews.tsx says every review is matched to a couple we
 *   accompanied — so add a review here ONLY after matching its author to a
 *   booking. A review you cannot match must not be added (or the note must
 *   go back to "without checking").
 */
export type GoogleReview = {
  /** Verbatim text; paragraphs are separated by a blank line. */
  text: string;
  stars: 1 | 2 | 3 | 4 | 5;
  /** Month the review was written, "YYYY-MM". */
  month: string;
  /** Google's price rating, as chosen by the reviewer (if any). */
  price?: "excellent" | "fair";
};

/**
 * Share link of the Google Business Profile "Danish Wedding" (knowledge graph
 * id /g/11zh719h0m), provided by the operator on 2026-09-26. Used for the
 * "all reviews on Google" link and the Google card in the trust band, so every
 * visitor can check the reviews at the source.
 */
export const GOOGLE_PROFILE_URL = "https://share.google/VdsN4635ojdtddrq2";

/** Newest first. Transcribed from the operator's screenshots of 2026-09-26. */
export const GOOGLE_REVIEWS: GoogleReview[] = [
  {
    stars: 5,
    month: "2026-09",
    text: "Ich muss Alex wirklich loben. Bei jeder Frage bemüht er sich, diese zu beantworten und einem zu helfen. Die Prämisse ist nicht „Das fällt nicht in den Umfang“, sondern: Wie gilt es, das Problem zu lösen? Ein großes Dankeschön!",
  },
  {
    stars: 5,
    month: "2026-09",
    price: "excellent",
    text: [
      "Ich habe Alex durch Zufall entdeckt und muss sagen: Ich bin von Grund auf begeistert von seiner Arbeit. Er hat uns von A bis Z begleitet und uns ohne den üblichen Stress durchgelotst.",
      "Wir hatten vorher selbst versucht, uns durch die dänischen Vorgaben zu arbeiten, und irgendwann den Überblick verloren, welche Unterlagen wirklich gebraucht werden und welche nicht. Alex hat das in einem Gespräch sortiert, uns eine klare Liste geschickt und den Schriftverkehr übernommen. Auf Rückfragen kam meist noch am selben Tag eine Antwort, und zwar eine konkrete und keine Standardfloskel.",
      "Besonders gut fand ich, dass nichts schöngeredet wurde. Wo es eng werden konnte, hat er es offen gesagt, statt uns hinzuhalten. Der Termin lief am Ende genau so ab wie vorher besprochen.",
      "Für alle, die vor demselben Bürokratie-Berg stehen: klare Empfehlung. Wir würden es wieder genauso machen",
    ].join("\n\n"),
  },
  {
    stars: 5,
    month: "2026-09",
    price: "excellent",
    text: "Ein großes Dankeschön an Danish Wedding und ganz besonders an Alexander! Von Anfang bis Ende super freundlich, professionell und zuverlässig. Dank ihm war unser Weg zur Hochzeit in Dänemark einfach und stressfrei. Absolute Empfehlung! ❤️",
  },
  {
    stars: 5,
    month: "2026-09",
    price: "fair",
    text: [
      "Ich habe Alex einem Freund empfohlen, der aufgrund bürokratischer Schwierigkeiten hier nicht heiraten konnte und deshalb nach einer Möglichkeit gesucht hat, in Dänemark zu heiraten.",
      "Die Unterstützung durch Alex und seine Agentur war von Anfang an sehr professionell, zuverlässig und unkompliziert. Der gesamte Ablauf hat reibungslos funktioniert, und mein Freund wurde bei allen wichtigen Schritten gut begleitet und unterstützt.",
      "Es freut mich sehr, dass alles so problemlos geklappt hat. Ich kann Alex und seine Agentur daher mit gutem Gewissen weiterempfehlen. Vielen Dank für die tolle Unterstützung!",
    ].join("\n\n"),
  },
];
